// @flow

import brandIcon from '../../../assets/img/product-features-icons/brand.svg';
import modelIcon from '../../../assets/img/product-features-icons/model.svg';
import genderIcon from '../../../assets/img/product-features-icons/gender.svg';
import ageIcon from '../../../assets/img/product-features-icons/age.svg';
import clotheType from '../../../assets/img/product-features-icons/clothe-type.svg';
import powerIcon from '../../../assets/img/product-features-icons/power.svg';
import materialIcon from '../../../assets/img/product-features-icons/material.svg';
import memoryIcon from '../../../assets/img/product-features-icons/memory.svg';
import styleIcon from '../../../assets/img/product-features-icons/style.svg';
import capacityIcon from '../../../assets/img/product-features-icons/capacity.svg';
import boltIcon from '../../../assets/img/product-features-icons/bolt.svg';
import resolutionIcon from '../../../assets/img/product-features-icons/resolution.svg';
import aspectRatioIcon from '../../../assets/img/product-features-icons/aspect-ratio.svg';
import batteryIcon from '../../../assets/img/product-features-icons/battery.svg';
import typeIcon from '../../../assets/img/product-features-icons/type.svg';
import lifeTimeIcon from '../../../assets/img/product-features-icons/life-time.svg';
import mantainmentIcon from '../../../assets/img/product-features-icons/maintainment.svg';
import warrantyIcon from '../../../assets/img/product-features-icons/warranty.svg';
import weightIcon from '../../../assets/img/product-features-icons/weight.svg';
import tasteIcon from '../../../assets/img/product-features-icons/taste.svg';
import colorIcon from '../../../assets/img/product-features-icons/color.svg';
import shapeIcon from '../../../assets/img/product-features-icons/shapes.svg';
import packIcon from '../../../assets/img/product-features-icons/pack.svg';
import featureIcon from '../../../assets/img/product-features-icons/feature.svg';
import sourceIcon from '../../../assets/img/product-features-icons/source.svg';
import proteinIcon from '../../../assets/img/product-features-icons/protein.svg';
import fatIcon from '../../../assets/img/product-features-icons/fat.svg';
import fiberIcon from '../../../assets/img/product-features-icons/fiber.svg';
import humidityIcon from '../../../assets/img/product-features-icons/humidity.svg';
import calciumIcon from '../../../assets/img/product-features-icons/calcium.svg';
import phosphorusIcon from '../../../assets/img/product-features-icons/phosphorus.svg';
import globeIcon from '../../../assets/img/product-features-icons/globe.svg';

//PRODUCT FEATURES
export type ProductFeature = {
  label: string,
  name: string,
  icon?: string,
};

export const PRODUCT_FEATURES = [
  {id: 'Marca', name: 'Marca', icon: brandIcon},
  {id: 'Modelo', name: 'Modelo', icon: modelIcon},
  {id: 'Género', name: 'Género', icon: genderIcon},
  {id: 'Edad', name: 'Edad', icon: ageIcon},
  {id: 'Tipo de prenda', name: 'Tipo de prenda', icon: clotheType},
  {id: 'Material', name: 'Material', icon: materialIcon},
  {id: 'Estilo', name: 'Estilo', icon: styleIcon},
  {id: 'Potencia', name: 'Potencia', icon: powerIcon},
  {id: 'Voltaje', name: 'Voltaje', icon: boltIcon},
  {id: 'Capacidad', name: 'Capacidad', icon: capacityIcon},
  {id: 'Memoria', name: 'Memoria', icon: memoryIcon},
  {id: 'Resolución', name: 'Resolución', icon: resolutionIcon},
  {id: 'Tamaño', name: 'Tamaño', icon: aspectRatioIcon},
  {
    id: 'Duración de la batería',
    name: 'Duración de la batería',
    icon: batteryIcon,
  },
  {id: 'Fuente', name: 'Fuente', icon: sourceIcon},
  {id: 'Propiedad', name: 'Propiedad', icon: featureIcon},
  {id: 'Tipo', name: 'Tipo', icon: typeIcon},
  {id: 'Color', name: 'Color', icon: colorIcon},
  {id: 'Forma', name: 'Forma', icon: shapeIcon},
  {id: 'Empaque', name: 'Empaque', icon: packIcon},
  {id: 'Tiempo de vida', name: 'Tiempo de vida', icon: lifeTimeIcon},
  {id: 'Sabor', name: 'Sabor', icon: tasteIcon},
  {id: 'Peso', name: 'Peso', icon: weightIcon},
  {id: 'Garantía', name: 'Garantía', icon: warrantyIcon},
  {id: 'Mantenimiento', name: 'Mantenimiento', icon: mantainmentIcon},

  {id: 'Proteína', name: 'Proteína', icon: proteinIcon},
  {id: 'Grasa', name: 'Grasa', icon: fatIcon},
  {id: 'Fibra', name: 'Fibra', icon: fiberIcon},
  {id: 'Humedad', name: 'Humedad', icon: humidityIcon},
  {id: 'Calcio', name: 'Calcio', icon: calciumIcon},
  {id: 'Fósforo', name: 'Fósforo', icon: phosphorusIcon},
  {
    id: 'País de Origen',
    name: 'País de Origen',
    icon: globeIcon,
  },
];

export function validateBulk(
  arrToValidate: any[],
  clearErrors: () => void,
  setError: (fieldName: string, {message: string}) => void
): void {
  const tempBulk = [...arrToValidate];
  clearErrors();
  // Clear Errors

  // arrToValidate.forEach((v, index) => {
  //   const fields = [
  //     `minimumQuantity-${index}`,
  //     `unitPrice-${index}`,
  //     `taxedUnitPrice-${index}`,
  //   ];

  //   clearErrors(fields);
  // });

  tempBulk.forEach((e, i) => {
    if (Number(e.unitPrice) === 0)
      setError(`unitPrice-${i}`, {message: 'Precio debe ser mayor a 0'});
    if (i === 0 && (e.minQuantity < 2 || !e.minQuantity)) {
      setError(`minimumQuantity-${i}`, {
        message: 'La cantidad no puede ser menor a 2 unidades',
      });
    } else if (i > 0 && i < tempBulk.length) {
      if (e.minQuantity <= tempBulk[i - 1].minQuantity) {
        setError(`minimumQuantity-${i}`, {
          message: 'La cantidad debe ser mayor a la fila anterior',
        });
      }
    }
  });
}

const YTVIDEO = 'SM-B8743B49';
const TKVIDEO = 'SM-8B248A49';
const IGVIDEO = 'SM-95A4E946';
const FBVIDEO = 'SM-FB89C3D2';
const VMVIDEO = 'SM-VM74E1A8';

const ytRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w]+\?v=|embed\/|v\/|shorts\/)?)(.{11})(\S+)?$/;
const ytNodeRegex = /<iframe.*((http|https)?:\/\/(www\.youtube\.com)\/embed\/(.{11}).*).*><\/iframe>/;

// TikTok patterns
const tkRegex = /(https?:\/\/)?(www\.|vm\.)?tiktok\.com\/@[\w.-]+\/video\/(\d+)/;
const tkRegex2 = /(https?:\/\/)?(www\.)?tiktok\.com\/embed\/(\d+)/;
const tkRegex3 = /(https?:\/\/)?vm\.tiktok\.com\/([\w]+)/; // Links cortos de TikTok
const tkNodeRegex = /<blockquote.*class="tiktok-embed".*data-video-id="(\d{19})".*>/;

// Instagram patterns
const igRegex = /(https?:\/\/)?(www\.)?instagram\.com\/(p|tv|reel)\/([\w-]+)/;
const igNodeRegex = /<blockquote.*class="instagram-media".*data-instgrm-permalink=".*\/(tv|reel|p)\/([\w-]+)\/?\?.*".*>/;

const fbRegex = /(https|http)?:\/\/(?:www\.)?(facebook)\.com\/.*\/videos\/(\d+)\/?/;
const fbRegex2 = /(https|http)?:\/\/(fb\.watch)\/([\w-]+)\/?/;
const fbNodeRegex = /<iframe.*src="https:\/\/www\.facebook\.com\/plugins\/video\.php\?.*".*><\/iframe>/;

const vmRegex = /(https|http)?:\/\/(player\.)?vimeo\.com\/(video\/)?(\d+)/;
const vmNodeRegex = /<iframe.*src="https:\/\/player\.vimeo\.com\/video\/(\d+).*".*><\/iframe>/;

export function getVideoType(str: string) {
  if (!str) return undefined;
  if (ytRegex.test(str) || ytNodeRegex.test(str)) return YTVIDEO;
  if (
    tkNodeRegex.test(str) ||
    tkRegex.test(str) ||
    tkRegex2.test(str) ||
    tkRegex3.test(str)
  ) {
    return TKVIDEO;
  }
  if (igNodeRegex.test(str) || igRegex.test(str)) {
    return IGVIDEO;
  }
  if (fbNodeRegex.test(str) || fbRegex.test(str) || fbRegex2.test(str)) {
    return FBVIDEO;
  }
  if (vmNodeRegex.test(str) || vmRegex.test(str)) {
    return VMVIDEO;
  }
  return undefined;
}

function getYoutubeId(str: string) {
  if (typeof str !== 'string') return null;

  const basePatterns = [
    /v=([a-zA-Z0-9_-]{11})/,
    /youtu\.be\/([a-zA-Z0-9_-]{11})/,
    /\/shorts\/([a-zA-Z0-9_-]{11})/,
    /\/embed\/([a-zA-Z0-9_-]{11})/,
  ];

  for (const pattern of basePatterns) {
    const match = str.match(pattern);
    if (match) {
      return match[1];
    }
  }

  return null;
}

export function getEmbedUrl(str: string, videoType: string) {
  if (videoType === YTVIDEO) {
    const ytId = getYoutubeId(str);
    if (ytId) {
      return `https://www.youtube.com/embed/${ytId}`;
    }
    return 'video not found';
  } else if (videoType === TKVIDEO) {
    // Primero intentar extraer de blockquote embed
    let match = tkNodeRegex.exec(str);
    if (match && match[1]) return `https://www.tiktok.com/embed/${match[1]}`;

    // Intentar de URL normal de video (@usuario/video/ID)
    match = tkRegex.exec(str);
    if (match && match[3]) return `https://www.tiktok.com/embed/${match[3]}`;

    // Intentar de URL embed directo
    match = tkRegex2.exec(str);
    if (match && match[3]) return `https://www.tiktok.com/embed/${match[3]}`;

    // Links cortos vm.tiktok.com - estos requieren redirección
    // Por ahora retornamos la URL original ya que TikTok los redirige
    match = tkRegex3.exec(str);
    if (match) {
      // Los links cortos no se pueden embeber directamente
      // Devolvemos undefined para que el componente muestre un mensaje
      return undefined;
    }
  } else if (videoType === IGVIDEO) {
    // Primero intentar de blockquote
    let match = igNodeRegex.exec(str);
    if (match && match[2])
      return `https://www.instagram.com/p/${match[2]}/embed`;

    // Intentar de URL normal
    match = igRegex.exec(str);
    if (match && match[4])
      return `https://www.instagram.com/p/${match[4]}/embed`;
  } else if (videoType === FBVIDEO) {
    // URL de video normal de Facebook
    let match = fbRegex.exec(str);
    if (match && match[3]) {
      return `https://www.facebook.com/plugins/video.php?height=314&href=${encodeURIComponent(
        str
      )}&show_text=false&width=560&t=0`;
    }

    // Link corto fb.watch
    match = fbRegex2.exec(str);
    if (match && match[3]) {
      return `https://www.facebook.com/plugins/video.php?height=314&href=${encodeURIComponent(
        str
      )}&show_text=false&width=560&t=0`;
    }

    // Ya es un iframe embed
    match = fbNodeRegex.exec(str);
    if (match) return str.match(/src="([^"]+)"/)?.[1];
  } else if (videoType === VMVIDEO) {
    // Primero intentar de iframe embed
    let match = vmNodeRegex.exec(str);
    if (match && match[1]) return `https://player.vimeo.com/video/${match[1]}`;

    // Intentar de URL normal
    match = vmRegex.exec(str);
    if (match && match[4]) return `https://player.vimeo.com/video/${match[4]}`;
  }

  return undefined;
}

export function validateVideoUrl(
  url: string
): {videoType: string, embed: string} | typeof undefined {
  const videoType = getVideoType(url);
  if (videoType) {
    const embed = getEmbedUrl(url, videoType);
    if (embed) {
      return {videoType, embed};
    }
  }

  return undefined;
}

export function getProductTaxFactor(
  taxes: {[key: string]: *, percentage: string}[] = []
) {
  return taxes.reduce(
    (acc, curr) => parseFloat(acc) + parseFloat(curr.percentage),
    1
  );
}
